import { TableHeading } from "../../../../components/common/table/TableDesign";

const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  PRICE: /^(([0-9]{0,9})|([.{1}]\d{0,2})|(\d+(\.\d{0,2})))?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};

export const typeTableHeadings: TableHeading[] = [
  { label: "#", align: "left" },
  { label: "Task", align: "left" },
  { label: "Ref", align: "left" },
  { label: "Time", align: "left" },
  { label: "Name", align: "left" },
  { label: "Volume(ft³)", align: "left" },
  { label: "Surveyor", align: "left" },
  { label: "Location", align: "left" },
  { label: "Distance", align: "left" },
  { label: "Dismantle", align: "left" },
  { label: "Paces", align: "left" },
  { label: "External", align: "left" },
  { label: "Prop Type", align: "left" },
  { label: "From Beds", align: "left" },
  { label: "Floors", align: "left" },
  { label: "Lift", align: "left" },
  { label: "Status", align: "left" },
  { label: "Pace To", align: "left" },
  { label: "External To", align: "left" },
  { label: "Property To", align: "left" },
  { label: "Beds To", align: "left" },
  { label: "Floor To", align: "left" },
  { label: "Lift To", align: "left" },
  { label: "Status To", align: "left" },
];

export const dummyTabsData = [
  {
    "tab": "Vehicles",
    "data": [
      { "name": "RFE", "count": 25 },
      { "name": "RBX", "count": 25 },
      { "name": "PNZ", "count": 25 },
      { "name": "PPX", "count": 25 },
      { "name": "EXR", "count": 25 },
      { "name": "NMS", "count": 25 }
    ]
  },
  {
    "tab": "Drivers",
    "data": [
      { "name": "Alan" },
      { "name": "Jess" },
      { "name": "Philip" },
      { "name": "Fred" },
      { "name": "Luca" }
    ]
  },
  {
    "tab": "Portal",
    "data": [
      { "name": "Portal-1" },
      { "name": "Portal-2" }
    ]
  }
];

